import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

const assetOptions: AssetOptionsContextProps = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
  alt: '',
}

const ContentfulContentArticleImageLeftDesktopImage: Utils.EntryFC<
  Queries.ContentfulContentArticleImageLeftDesktopImageFragment
> = ({ content: { image }, entryInspectorProps, fieldInspectorProps }) => (
  <div className="hidden h-full w-full laptop:block" {...entryInspectorProps()}>
    <div
      className="p-8"
      {...fieldInspectorProps({
        fieldId: 'image',
      })}
    >
      <AssetOptionsContext.Provider value={assetOptions}>
        <Entry
          content={image}
          mapping={{
            [ContentType.ContentfulAsset]: ContentfulAsset,
          }}
        />
      </AssetOptionsContext.Provider>
    </div>
  </div>
)

export const query = graphql`
  fragment ContentfulContentArticleImageLeftDesktopImage on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    image {
      ...ContentfulDefaultAsset
    }
  }
`

export default withDisplayName(
  ContentfulContentArticleImageLeftDesktopImage,
  'ContentfulContentArticleImageLeftDesktopImage'
)
